// extracted by mini-css-extract-plugin
export var filterIncDec = "_4f-0";
export var leftBorder = "_4f-1";
export var rightBorder = "_4f-2";
export var stringInput = "_4f-3";